<div class="center center-container" [hidden]="aboutInformationIsEmpty()">

  <div class="support-logo">
    <i class="greydom-support-logo"></i>
  </div>

  <p>{{aboutInformation.description}}</p>
  <p><B>Updates</B>: {{aboutInformation.updates}}</p>
  <p><B>Version</B>: {{aboutInformation.version}}</p>
  <p><B>Support Email</B>: {{aboutInformation.supportEmail}}</p>

  <button class="button-spacer fit-content" mat-raised-button color="primary" (click)="goToLink(serviceDeskUrl)">
    <mat-icon>open_in_new</mat-icon>
    View Requests
  </button>

</div>